import { render } from "./Favourite.vue?vue&type=template&id=7788dbfb&scoped=true"
import script from "./Favourite.vue?vue&type=script&lang=js"
export * from "./Favourite.vue?vue&type=script&lang=js"

import "./Favourite.vue?vue&type=style&index=0&id=7788dbfb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7788dbfb"]])

export default __exports__